import { createSlice } from "@reduxjs/toolkit";
import { fetchSoloProposalUrl, syncSoloProposal } from "./solo.actions";

export interface SoloState {
  syncErrors?: string;
  iframeLoadingErrors?: string;
  soloProposalUrl?: string;
  iframeLoaded: boolean;
  modelSaving: boolean;
}
const initialState: SoloState = {
  syncErrors: undefined,
  iframeLoadingErrors: undefined,
  soloProposalUrl: undefined,
  modelSaving: false,
  iframeLoaded: false,
};

const soloSlice = createSlice({
  name: "solo",
  initialState,
  reducers: {
    fetchSoloProposalUrl(state) {},
    syncSolo(state) {},
  },
  extraReducers: builder => {
    builder
      .addCase(fetchSoloProposalUrl.pending, (state, action) => {
        state.iframeLoadingErrors = undefined;
        state.iframeLoaded = false;
      })
      .addCase(fetchSoloProposalUrl.fulfilled, (state, action) => {
        state.iframeLoaded = true;
        state.soloProposalUrl = action.payload;
      })
      .addCase(fetchSoloProposalUrl.rejected, (state, action: any) => {
        state.iframeLoaded = false;
        const errorMessage = action.payload?.errors?.message;
        state.iframeLoadingErrors = errorMessage || action.error.message;
        state.soloProposalUrl = undefined;
      })
      .addCase(syncSoloProposal.pending, (state, action) => {
        state.syncErrors = undefined;
      })
      .addCase(syncSoloProposal.fulfilled, (state, action) => {})
      .addCase(syncSoloProposal.rejected, (state, action: any) => {
        const errorMessage = action.payload?.errors?.message;
        state.syncErrors = errorMessage || action.error.message;
      });
  },
});

export const { syncSolo } = soloSlice.actions;

export default soloSlice;
